<div>
	<ng-template class="w-100" #step10>
		<div class="copilot-custom copilop-info edit-sidebar-cop" style="position: sticky;">
			<div class="row">
				<div class="col-12 flex justify-content-center align-items-center">
					<h3 class="title-info">
						{{'TUTORIALINICIO.TUTORIAL_TEXTO_00'| translate}}
					</h3>
				</div>
				<div class="col-12 ">
					<p class="text-info-help">
						<!-- {{'TUTORIALINICIO.TUTORIAL_TEXTO_01'| translate}}-->
					</p>
				</div>
			</div>
			<div class="footer-btn">
				<div class="row  flex justify-content-center align-items-center">
					<div class="col-2">
						<button class="btn btn-block btn-themecolor btn-sm button-ok" (click)="done()" type="button">
							{{'TUTORIALINICIO.BOTONES.ACEPTAR'| translate}}
						</button>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</div>

<div class="gif_container" hidden>
	<div class="dedo">
		<div class="row">
			<div class="col-6">
				<img class="img_dedo_nodo" [src]="urlTutorial + 'dedodellado.gif'" alt="">
			</div>
			<div class="col-6">
				<img class="img_dedo_quiz" [src]="urlTutorial + 'dedodellado.gif'" alt="">
			</div>
			<div class="col-12">
				<img [src]="urlTutorial + 'dedodesdeabajo.gif'" alt="">
			</div>
		</div>
	</div>
</div>

<div class="left-sidebar show-avatar" *ngIf="shouldShowAvatar"
	[ngClass]="{'show-avatar-student' : loginService.esEstudiante()}">
	<app-user-account></app-user-account>
</div>

<!--
<div *ngIf="loginService.esProfesor() || loginService.esAutor()" class="left-sidebar show-avatar show-avatar-agent" [ngClass]="{ 'agent-width': showIconAgent }">
	<app-agent-display (_showUserAccount)="_showUserAccount($event)"></app-agent-display>
</div>
-->

<div class="opt-float" *ngIf="loginService.esProfesor() || loginService.esAutor()">
	<!-- BOTON PARA VER LOS TUTORIALES
	<button nbButton nbTooltip="Ver Tutoriales" nbTooltipPlacement="right" (click)="verTutoriales()" class="chat">
		<div *ngIf="tutorialesActivos" class="d-flex">
			<img src="../../../../assets/images/icons/youtube-menu.webp" width="30" alt="Youtube">
		</div>
		<div *ngIf="!tutorialesActivos" class="d-flex">
			<img src="../../../../assets/images/icons/youtube-logo-icone-grise.png" width="25" alt="Youtube">
		</div>
	</button>
	 -->
	<!-- BOTON PARA VER EL CHAT-->
	<button nbButton nbTooltip="{{ 'CHAT.VIEW' | translate }}" nbTooltipPlacement="right"
		*ngIf="loginService.esProfesor() && localStorage.getItem('selectedGroupInfo')" (click)="verChat()" class="chat"
		[ngClass]="{ 'chatActiveBotton': newMessageChat && !localStorage.getItem('chatActive') }">
		<img src="../../../../assets/images/control-panel/charlar.png" width="30" />
		<div class="chatActive" *ngIf="newMessageChat && !localStorage.getItem('chatActive')">
			<span>!</span>
		</div>
	</button>

	<!-- BOTONES PARA VER EL GRAFO ANTERIOR Y SIGUIENTE COMO PROFESOR-->
	<div class="d-flex flex-column align-items-center" *ngIf="loginService.esProfesor()">
		<div *ngIf="this.graphVisited_Student.length > 1 && this.graphVisited_Student[this.graphVisited_Student.length - 1].idGrafo != this.lastTarget"
			class="d-flex justify-content-center align-items-center pointer gap-2 previous-target"
			(click)="verGrafoAnterior()">
			<img width="35" src="../../../../assets/icons/anterior.svg">
			<p class="texto-pequeno">{{ 'PADS.PREVIOUSTARGET' | translate }}</p>
		</div>

		<div *ngIf="this.graphVisited_Student.length > 1 && this.graphVisited_Student[0].idGrafo != this.lastTarget"
			class="d-flex justify-content-center align-items-center pointer gap-2 next-target"
			(click)="verGrafoSiguiente()">
			<p class="texto-pequeno">{{ 'PADS.NEXTTARGET' | translate }}</p>
			<img width="35" src="../../../../assets/icons/siguiente.svg">
		</div>
	</div>

	<!-- BOTONES PARA VER EL GRAFO ANTERIOR Y SIGUIENTE COMO EDITOR-->
	<div class="d-flex flex-column align-items-center" *ngIf="loginService.esAutor()">
		<div *ngIf="this.graphVisited_Editor.length > 1 && this.graphVisited_Editor[this.graphVisited_Editor.length - 1].idGrafo != this.lastTarget_Editor"
			class="d-flex justify-content-center align-items-center pointer gap-2 previous-target"
			(click)="verGrafoAnteriorEditor()">
			<img width="35" src="../../../../assets/icons/anterior.svg">
			<p class="texto-pequeno">{{ 'PADS.PREVIOUSTARGET' | translate }}</p>
		</div>

		<div *ngIf="this.graphVisited_Editor.length > 1 && this.graphVisited_Editor[0].idGrafo != this.lastTarget_Editor"
			class="d-flex justify-content-center align-items-center pointer gap-2 next-target"
			(click)="verGrafoSiguienteEditor()">
			<p class="texto-pequeno">{{ 'PADS.NEXTTARGET' | translate }}</p>
			<img width="35" src="../../../../assets/icons/siguiente.svg">
		</div>
	</div>
</div>

<!-- MODAL PARA MOSTRAR EL LISTADO DE VIDEOS -->
<nb-card
	*ngIf="isModalOpen && (loginService.esEstudiante() || loginService.esProfesor() || loginService.esAutor()) && !isMobile"
	class="container-tutorial small-video-tutorial mb-0"
	[ngStyle]="{ top: modalPosition.top + 'px', left: modalPosition.left + 'px' }"
	(mousedown)="startDragging($event, 'main')">
	<nb-card-header class="border-bottom-0 p-1 background_themecolor">
		<div class="d-flex justify-content-center align-items-center flex-column gap-2 position-relative">
			<img class="icon-drag_indicator" src="../../../../assets/images/icons/drag_indicator.svg">
			<h6>Tutoriales</h6>
		</div>
	</nb-card-header>

	<div class="closeModal-tutorial">
		<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }" (click)="closeModal()"
			nbTooltip="{{ 'SIGMACOMPONENT.CERRAR' | translate }}" nbTooltipPlacement="left">
		</nb-icon>
	</div>

	<nb-card-body class="p-0">
		<nb-card class="mb-0 no-edge-card background_themecolor">
			<nb-card-body class="px-3 py-0">
				<div class="d-flex justify-content-center flex-wrap gap-3">
					<!-- Lista de videos -->
					<div class="card card-video" *ngFor="let video of videoList; let i = index">
						<div class="video-overlay"
							[class.overlay-active]="isVideoModalOpen && selectedVideoIndex === i">
							<img (click)="openVideoModal(i, video.urlVideo)" class="card-img-video pointer"
								[src]="'https://img.youtube.com/vi/' + getVideoId(video.urlVideo) + '/hqdefault.jpg'"
								alt="{{ video.title }}">
							<div (click)="openVideoModal(i, video.urlVideo)"
								class="d-flex detail-tutorial align-items-center justify-content-between p-2 pointer">
								<p class="title-video" nbTooltip="{{ video.title }}" nbTooltipPlacement="top">{{
									video.title }}</p>
								<img class="icon-youtube" src="../../../../assets/images/icons/youtube.png"
									nbTooltip="Abrir Video" nbTooltipPlacement="right">
							</div>
							<!-- Icono de reproducción superpuesto -->
							<!-- <nb-icon *ngIf="isVideoModalOpen && selectedVideoIndex === i" class="overlay-icon" icon="play-circle-outline"></nb-icon> -->
							<img *ngIf="isVideoModalOpen && selectedVideoIndex === i" class="overlay-icon"
								src="../../../../assets/images/icons/sonido-de-onda.png">
						</div>
					</div>
				</div>
			</nb-card-body>
		</nb-card>
	</nb-card-body>

	<nb-card-footer class="p-2 background_themecolor border-top-0"></nb-card-footer>
</nb-card>

<!-- MODAL PARA MOSTRAR EL VIDEO -->
<nb-card
	*ngIf="isVideoModalOpen && (loginService.esEstudiante() || loginService.esProfesor() || loginService.esAutor()) && !isMobile"
	class="container-tutorial medium-video-tutorial mb-0"
	[ngStyle]="{ top: videoModalPosition.top + 'px', left: videoModalPosition.left + 'px' }"
	(mousedown)="startDragging($event, 'video')">
	<nb-card-header class="border-bottom-0 p-1 background_themecolor">
		<div class="d-flex justify-content-center align-content-center position-relative">
			<img class="icon-drag_indicator" src="../../../../assets/images/icons/drag_indicator.svg">
		</div>
	</nb-card-header>

	<div class="closeModal-tutorial">
		<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }" (click)="closeVideoModal()"
			nbTooltip="{{ 'SIGMACOMPONENT.CERRAR' | translate }}" nbTooltipPlacement="left">
		</nb-icon>
	</div>

	<nb-card-body class="p-0">
		<nb-card class="mb-0 no-edge-card background_themecolor">
			<nb-card-body class="px-3 py-0">
				<div class="iframe-container">
					<iframe [src]="videoUrl" frameborder="0" allowfullscreen></iframe>
				</div>
			</nb-card-body>
		</nb-card>
	</nb-card-body>

	<nb-card-footer class="p-2 background_themecolor border-top-0"></nb-card-footer>
</nb-card>

<!-- MODAL PARA MOSTRAR EL CHAT-->
<div *ngIf="localStorage.getItem('chatActive')">
	<app-modal-chat></app-modal-chat>
</div>